import { useAppSelector } from "../store/index.ts";

export default function useBilling() {
  const chatActiveMode = useAppSelector((state) => state.chat.chatActiveMode);
  const exclusiveInfo = useAppSelector((state) => state.chat.settingInfo["exclusive-chat"]);
  const privateInfo = useAppSelector((state) => state.chat.settingInfo["private-chat"]);
  const paidInfo = useAppSelector((state) => state.chat.settingInfo["paid-chat"]);
  const viewInfo = useAppSelector((state) => state.chat.settingInfo["view-chat"]);
  const activeModeInfo = useAppSelector((state) => state.chat.settingInfo[chatActiveMode]);

  const exclusiveBilling = exclusiveInfo?.billing;
  const privateBilling = privateInfo?.billing;
  const paidBilling = paidInfo?.billing;
  const viewBilling = viewInfo?.billing;
  const exclusiveDescribe = exclusiveInfo?.["describe-service"];
  const privateDescribe = privateInfo?.["describe-service"];

  return {
    activeModeInfo,
    billing: {
      exclusiveBilling,
      privateBilling,
      paidBilling,
      viewBilling,
    },
    describe: {
      exclusiveDescribe,
      privateDescribe,
    },
  };
}
